import React from 'react';
import { Shield, Users, Briefcase, GraduationCap } from 'lucide-react';

const items = [
  { icon: <Shield className="w-5 h-5" />, label: '15+ Years Industry Experience' },
  { icon: <Users className="w-5 h-5" />, label: '5000+ Learners Trained' },
  { icon: <Briefcase className="w-5 h-5" />, label: 'Practical Industry Training' },
  { icon: <GraduationCap className="w-5 h-5" />, label: 'Career Assistance' }
];

const TrustStrip = () => (
  <section data-testid="trust-strip" className="bg-gradient-to-r from-black via-[#0b0b1a] to-black border-y border-yellow-500/20 py-5 px-4 relative z-10">
    <div className="container mx-auto max-w-6xl">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-3 justify-center md:justify-start">
            <div className="w-9 h-9 rounded-lg bg-yellow-500/15 text-yellow-300 flex items-center justify-center flex-shrink-0">
              {it.icon}
            </div>
            <span className="text-xs md:text-sm font-semibold text-white/85">{it.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustStrip;
